import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

export const useScreeningStore = defineStore('screening', () => {
  const shouldCheckLatestWaitingScreening = useStorage('should-check-latest-waiting-screening', true, sessionStorage)
  const showFindYourDoctorHomeBanner = useStorage('show-find-your-doctor-home-banner', true, localStorage)

  return {
    shouldCheckLatestWaitingScreening,
    showFindYourDoctorHomeBanner,
  }
})
